const EMPTY_TOTAL = Object.freeze({ activity: null, emissions: null });

const toText = (value) => (value === null || value === undefined ? null : String(value));

/**
 * Normalizes the POST /api/emissions/result-summary payload into the view
 * model shared by the import result table and the result dialog.
 */
export function normalizeResultSummary(payload) {
  const rows = Array.isArray(payload?.rows) ? payload.rows : [];
  return {
    fiscalYear: Number(payload?.fiscal_year) || null,
    source: toText(payload?.source),
    rows: rows.map((row, index) => ({
      id: toText(row?.id) || `row-${index}`,
      key: `${toText(row?.id) || `row-${index}`}:${index}`,
      label: toText(row?.label),
      labelKey: toText(row?.label_key),
      legalEntity: toText(row?.legal_entity),
      parentId: toText(row?.parent_id),
      level: row?.level === null || row?.level === undefined ? null : Number(row.level),
      activity: toText(row?.activity),
      activityUnit: toText(row?.activity_unit),
      efValue: toText(row?.ef_value),
      efUnit: toText(row?.ef_unit),
      emissions: toText(row?.emissions),
      rawRecords: row?.raw_records === null || row?.raw_records === undefined ? null : Number(row.raw_records),
      status: toText(row?.status),
    })),
    total: {
      activity: toText(payload?.total?.activity),
      emissions: toText(payload?.total?.emissions),
    },
  };
}

export { EMPTY_TOTAL };